import { getStoresByStates, GET_STORES_BY_STATES_ENDPOINT } from '@src/service/stores'
import { StoresByState } from '@src/types/strapi/collections/storesByState'
import useSWR from 'swr'

export const useStores = () => useSWR<StoresByState[]>(GET_STORES_BY_STATES_ENDPOINT, getStoresByStates)
